'use strict';

require('../../style/index.less');

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/lib/switch/style/index.js
// module id = 1158
// module chunks = 0